<template>
  <v-container fill-height align-center>
    <v-row class="px-8" justify="center">
      <v-col cols="12">
        <v-row align="center" justify="center">
          <div :class="`text-xs-center  ${ $vuetify.breakpoint.xs ? 'headline mb-2' : $vuetify.breakpoint.sm ? 'display-2 mb-4' : 'display-2 mb-3' }`">
            {{ $language.registration["Add Profile Photo"] }}
          </div>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-avatar size="200" class="grey" @click="dialog = true">
            <v-img :src="((userProfile || {}).public || {}).photoURL" alt="">
              <v-layout fill-height row justify-center align-center>
                <v-icon size="60" color="grey lighten-3">edit</v-icon>
              </v-layout>
            </v-img>
          </v-avatar>
        </v-row>
      </v-col>
      <v-progress-linear v-if="uploading" :value="progressUpload"></v-progress-linear>

      <v-col cols="12" lg="8">
        <v-row align="center" justify="center">
          <v-btn block style="height: 60px;" color="primary" class="px-0 ma-0" @click="$emit('next')" :disabled="!((userProfile.public||{}).photoURL) || (!uploadEnd && !initial)">
            {{ $language.registration["Next"] }}
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent :max-width="$vuetify.breakpoint.smAndDown ? 270 : 330">
      <v-card>
        <v-row >
          <v-col cols="12" justify="center" align="center">
            <croppa :key="myKey" ref="myCroppa" :width="$vuetify.breakpoint.smAndDown ? 250  : 300" :height="$vuetify.breakpoint.smAndDown ? 250 : 300" :placeholder="$language.registration['Add a photo']" :placeholder-font-size="22" :disabled="false" :prevent-white-space="true" :show-remove-button="true" :accept="'image/*'" @new-image-drawn="detectFiles" @file-choose="initial = false">
            </croppa>
          </v-col>
          <v-col cols="12" align="center">
            <v-btn fab small class="ma-1" color="primary" @click="rotatePhoto(-1)">
              <v-icon large>rotate_left</v-icon>
            </v-btn>
            <v-btn fab small class="ma-1" color="primary" @click="rotatePhoto(1)">
              <v-icon large>rotate_right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row no-gutters align="center" justify="space-around" class="px-2">
            <v-col cols="5">
              <v-btn color="primary" block large text @click.native="dialog = false">Cancel</v-btn>
            </v-col>
            <v-col cols="5">
              <v-btn @click="upload" color="primary" block large>Upload</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  <!-- <v-layout column fill-height align-space-around justify-space-around>
  <v-layout row wrap justify-center align-center>
    <v-flex xs12>
      <v-layout row wrap justify-center align-center>
        <v-flex xs12>
          <div :class="`text-xs-center grey--text text--darken-4 ${ $vuetify.breakpoint.xs ? 'headline mb-2' : $vuetify.breakpoint.sm ? 'display-2 mb-4' : 'display-2 mb-3' }`">
            {{ $language.registration["Add Profile Photo"] }}
          </div>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap justify-center align-center>
            <v-avatar size="200" class="grey" @click="dialog = true">
              <v-img :src="((userProfile || {}).public || {}).photoURL" alt="">
                <v-layout fill-height row justify-center align-center>
                  <v-icon size="60" color="grey lighten-3">edit</v-icon>
                </v-layout>
              </v-img>
            </v-avatar>

          </v-layout>
        </v-flex>
        <v-flex xs6>
          <v-progress-linear v-if="uploading" :value="progressUpload"></v-progress-linear>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex style="min-height: 80px; max-height: 80px;">
      <v-btn block style="height: 60px;" color="primary" class="px-0 ma-0" @click="$emit('next')" :disabled="!((userProfile.public||{}).photoURL) || (!uploadEnd && !initial)">
        {{ $language.registration["Next"] }}
      </v-btn>
    </v-flex>
  </v-layout>

  <v-dialog v-model="dialog" persistent :max-width="$vuetify.breakpoint.xs ? 232 : $vuetify.breakpoint.sm ? 282 : 332">
    <v-card>
      <v-card-text class="px-0 pt-4">
        <v-layout row wrap justify-center>
          <croppa :key="myKey" ref="myCroppa" :width="$vuetify.breakpoint.xs ? 200 : $vuetify.breakpoint.sm ? 250 : 300" :height="$vuetify.breakpoint.xs ? 200 : $vuetify.breakpoint.sm ? 250 : 300" :placeholder="$language.registration['Add a photo']"
            :placeholder-font-size="22" :disabled="false" :prevent-white-space="true" :show-remove-button="true" :accept="'image/*'" @new-image-drawn="detectFiles" @file-choose="initial = false">
          </croppa>

        </v-layout>
        <v-layout row align-center justify-center pt-2>
          <v-btn fab small color="transparent" @click="rotatePhoto(-1)">
            <v-icon large color="primary">undo</v-icon>
          </v-btn>
          <v-btn fab small color="transparent" @click="rotatePhoto(1)">
            <v-icon large color="primary">redo</v-icon>
          </v-btn>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="dialog = false">Cancel</v-btn>
        <v-btn color="primary" flat @click="upload">Upload</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-layout> -->
</template>

<script>
import {
  mapState
} from 'vuex'
const fb = require('@/services/firebaseConfig.js')
// import FileUploader from '@/components/common/File-Uploader'

export default {
  // components: { FileUploader },
  data () {
    return {
      initial: true,
      uploadReady: false,
      uploading: false,
      uploadEnd: false,
      progressUpload: 0,
      fileName: '',
      uploadTask: '',
      downloadURL: '', // What is this for?
      myKey: 0,
      dialog: false
    }
  },
  watch: {
    uploadTask: function () {
      this.uploadTask.on('state_changed', sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      },
      null,
      () => {
        this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          this.uploadEnd = true
          this.uploading = false
          var updates = {}
          updates[`user/${this.currentUser.uid}/profile/public/photoURL`] = downloadURL
          fb.database.ref().update(updates)
          // this.downloadURL = downloadURL
          // this.userProfile.photoURL = downloadURL
          // this.$emit('downloadURL', downloadURL) // What is this emit doing here?
        })
      })
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'categories'])
  },
  methods: {
    detectFiles () {
      this.uploadReady = true
    },
    rotatePhoto (dir) {
      this.$refs.myCroppa.rotate(dir)
    },
    upload () {
      this.dialog = false
      this.$refs.myCroppa.generateBlob(
        (blob) => {
          this.fileName = blob.name
          this.uploading = true
          this.uploadTask = fb.storage.ref(`images/${this.currentUser.uid}/profile_photo`).put(blob)
        },
        'image/jpeg'
      )
    },

    async removeImage () {
      this.myKey += 1
      this.$refs.myCroppa.remove()
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/photoURL`] = ''
      await fb.database.ref().update(updates)
      this.uploadEnd = false
      this.uploading = false
      this.uploadReady = false
      this.initial = true
    }
  }
}
</script>

<style>
.canvas-container {
  background: #fff;
  border: 2px solid #aaa;
  border-radius: 50%;
  margin: 14px 14px;
  overflow: hidden;
}
</style>
